import { Batch, BatchEntityType } from "../types/batch";

// TODO would like to move this work to the server. This is ugly
function getLatestBatchesByPlatform(batches: Batch[] = []) {
  // group batches by platform
  const byPlatform = batches.reduce(
    (acc, batch) => {
      const platform = batch.info?.platform;
      if (typeof platform === "string" && platform) {
        acc[platform] = acc[platform] ? [...acc[platform], batch] : [batch];
      }
      return acc;
    },
    {} as { [k: string]: Batch[] }
  );

  // sort from most to least recent and take the most recent
  // per platform
  const res = Object.values(byPlatform).flatMap((batches: Batch[]) => {
    const sorted = [...batches.sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())];
    return sorted[0];
  });

  return res;
}

function groupBatchesByAdAssetGroupId(batches: Batch[]) {
  return batches.reduce(
    (acc, batch) => {
      if (batch.entityId && batch.entityType === BatchEntityType.AdAssetGroup) {
        acc[batch.entityId] = acc[batch.entityId] ? [...acc[batch.entityId], batch] : [batch];
      }
      return acc;
    },
    {} as { [k: number]: Batch[] }
  );
}

export function getLatestBatchesForAdAssetGroup(id: number, batches: Batch[]) {
  const grouped = groupBatchesByAdAssetGroupId(batches);
  return getLatestBatchesByPlatform(grouped[id]);
}
